import DialogComponent from "components/Dialog";

import { ReactComponent as PinIcon } from 'icons/components/pin.svg';
import { ReactComponent as CloseIcon } from 'icons/components/bufferClose.svg';

const trKey = "treatmentPlan";

export default class PinVisitsDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            mainMode: true,
            showCanceled: true,
        };

        this.state = {
            ...this.defaultState,
            selectedVisit: false,
            visitsAttached: [],
            visitsNoAttached: [],
        };
    }

    async show(info, saveCb) {
        this.planInfo = info || {};
        this.saveCb = saveCb;
        this.setModeState();
        super.show();
    }

    async onShow() {
        await this.getData();
    }

    async getData() {
        const { clientId, id } = this.planInfo;
        this._helper.showLoading();
        const resp = await this._request.visits.getForTreatmentTask(clientId, id);
        const respNoAttached = await this._request.visits.getForNotAttached(clientId);
        this._helper.hideLoading();

        const visitsAttached = resp?.data || [];
        const visitsNoAttached = respNoAttached?.data || [];

        this.setState({ visitsNoAttached, visitsAttached });
    }

    toggleMode() {
        this.state.mainMode = !this.state.mainMode;
        this.setModeState();
        this.forceUpdate();
    }

    setModeState() {
        const { title } = this.planInfo;
        const { mainMode } = this.state;

        const t = "^" + this.t(mainMode ? "stageVisits" : "attachingVisitsTo").replace("$1", title);

        if (mainMode)
            this.dialogTitle = t;
        else
            this.setDialogBackTitle(t, this.toggleMode.bind(this));

        this.dialogSaveLabel = `${trKey}.${mainMode ? "attachingVisits" : "pinVisit"}`;

        this.hideBackButton = !mainMode;
    }

    async save() {
        if (this.state.mainMode)
            return this.toggleMode();

        if (this.saveCb?.apply) {
            await this.saveCb(this.state.selectedVisit, this.planInfo.id);
            await this.getData();
            this.showNotify("Визит прикреплен", "Успешно");
        }


        //this.hide();
    }

    t(value) {
        return this.tr(trKey, value);
    }

    async unAttachVisit(visitId) {

        this._helper.showLoading();
        await this._request.visits.update(visitId, {
            treatmentTaskId: null
        });
        this._helper.hideLoading();

        await this.getData();

    }

    onUnAttachVisit(id) {
        this._helper.confirm(
            { title: "client.unAttachVisit", message: this.tr("client.unAttachVisitConfirm") },
            this.unAttachVisit.bind(this, id)
        );
    }

    insertVisit(info, withPin, active) {
        const { selectedVisit } = this.state;
        const { id, status, beginDate, endDate } = info;
        const col = status === "WI_CANCELED" ? "colSec" : "paragraf";
        const date = this._helper.date.toPeriodStr(beginDate, endDate);

        return (
            <div key={id}
                onClick={active ? this.changeState.bind(this, "selectedVisit", id) : null}
                className={`itemHover ${selectedVisit === id ? "active" : ""} flex between centerV text p1SemiBold ${col} pad8 rad4 hand`}>
                <div className="flex gap8">
                    {withPin && (<PinIcon className="fillSec" />)}
                    {date}
                </div>
                {!active && <div className="closeIcon" onClick={this.onUnAttachVisit.bind(this, id)}>
                    <CloseIcon className="close" />
                </div>}
            </div>
        );
    }

    insertShowHideSize() {
        const { showCanceled } = this.state;

        return (
            <div className="colLink hand" onClick={this.toggleState.bind(this, "showCanceled")}>
                {this.tr("invoice", showCanceled ? "hideCanceled" : "showCanceled")}
            </div>
        );
    }

    insertVisistsBlock(leftText, useRight, withPin, items, active) {
        return (
            <div className="flex col gap8">
                <div className="flex between text p2">
                    <div className="rowText">{this.t(leftText)}</div>
                    <div></div>
                    {/*useRight ? this.insertShowHideSize() : <div></div>*/}
                </div>
                <div className="flex col gap4 borderBlock rad8 pad8 scrolling" style={{ maxHeight: "200px" }}>
                    {items.map(it => this.insertVisit(it, withPin, active))}
                </div>
            </div>
        );
    }

    renderMain() {
        const { showCanceled, visitsAttached } = this.state;

        const total = this.planInfo.duration || 0;
        //const passed = 8;
        //const left = total - passed;

        const items = [];
        const futureItems = [];

        visitsAttached.forEach(it => {
            const { status } = it;

            if (status === "WI_CREATED")
                futureItems.push(it);
            else if (showCanceled || status !== "WI_CANCELED")
                items.push(it);
        });

        return (
            <div className="content flex col gap16">
                <div className="flex col gap8 text p1">
                    <div className="flex gap16">
                        <div className="rowText">{this.t("stageVisitsScheduled")}</div>
                        <div className="paragraf">{total}</div>
                    </div>
                    <div className="flex gap16">
                        <div className="rowText">{this.t("passedVisits")}</div>
                        <div className="paragraf">{items.length}</div>
                        <div className="colSec">{`(${this.tr("main.left").toLowerCase()} ${total - items.length})`}</div>
                    </div>
                </div>
                {this.insertVisistsBlock("pastVisits", 1, 1, items)}
                {this.insertVisistsBlock("futureVisits", 0, 1, futureItems)}

            </div>
        );
    }

    renderAttach() {
        const { visitsNoAttached } = this.state;
        return (
            <div className="content flex col gap16">
                {this.insertVisistsBlock("unattachedVisits", 0, 1, visitsNoAttached, true)}
            </div>
        );
    }

    renderContent() {
        const { mainMode } = this.state;

        return mainMode ? this.renderMain() : this.renderAttach();
    }
}
